var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header", { attrs: { title: "" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "boss-admin-container clearfix" },
        [
          _c("sidebar"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boss-main-container pega-error-container" },
            [
              _c("div", { staticClass: "boss-main-wrap" }, [
                _c(
                  "div",
                  { staticClass: "grid-container margin-auto text-center" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "boss-more-button margin-top-2" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "float-center boss-button-center boss-button-large",
                            attrs: { "data-test": "dashboard-button" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "dashboardTop",
                                })
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              ダッシュボードに戻る\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-size-1-5em" }, [
      _c("div", [_vm._v("404")]),
      _vm._v(" "),
      _c("img", {
        staticClass: "pega-mb-1-5",
        attrs: { src: require("@/assets/images/littlemy_404_C.png") },
      }),
      _vm._v(" "),
      _c("div", [_vm._v("お探しのページは見つかりません")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-size-1em margin-top-1" }, [
      _c("div", [
        _vm._v(
          "でも、お探しの人はちゃんと見つかって素敵な採用へつながりますように。"
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "女の転職typeはそのお役に立てるよう、もっともっと成長していきますね！"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }